import {Component, HostListener, Inject, Input, OnInit} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {CardStoreService} from '../shared/card-store.service';
import {UserValidation} from '../shared/user-validation';
import {Observable} from 'rxjs';
import {CardWebConnectorService} from '../shared/card-web-connector.service';
import {Router} from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'em-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
/**
 * Defines the common Header in the app with the central menu.
 */
export class HeaderComponent implements OnInit {
  @Input() leftSideNav: MatSidenav;
  userValidation$: Observable<UserValidation>;
  mobile: boolean;
  private routePath = '';
  designName = '';
   currentWindowWidth: number;
  shareOption: string;

  constructor(private cs: CardStoreService, private cwcs: CardWebConnectorService,  private router: Router,
              private location: Location) {
  }

  ngOnInit(): void {
    this.currentWindowWidth = window.innerWidth;
    this.cs.getUserLoginListener().subscribe(b => this.userValidation$ = b);
    this.cwcs.getDesignIdChangeEvent().subscribe( designId => {
      this.designName = designId;
    });
    this. cwcs.getDesignShareOption().subscribe( shareOption => {
      this.shareOption = shareOption;
    });
    this.router.events.subscribe(() => {
      if (this.location.path() !== '') {
        this.routePath = this.location.path();
      } else {
        this.routePath = 'Home';
      }
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.currentWindowWidth = window.innerWidth;
  }

  public isOnActiveRoute(routeName: string): boolean {
    return this.routePath.includes(routeName);
  }
}
